import { EventChannel } from '@domain/channel';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

const getEventChannelsByIdFetch = async (companyClubId: string) => {
  const url = `${import.meta.env.VITE_EVENTS_HOST}/v1/nightgraph/company-clubs/${companyClubId}/channels`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetCompanyClubChannels = ({
  companyClubId,
  options,
}: {
  companyClubId: string;
  options?: Record<string, boolean>;
}) => {
  return useGenericQuery<EventChannel[], RequestError>(
    ['company-club-channels-by-id', companyClubId],
    () => getEventChannelsByIdFetch(companyClubId),
    { ...options }
  );
};
